import React from "react"
import logo from "../../Assets/la-fille-logo.png"
import { Link } from "react-router-dom"
import { motion } from "framer-motion"

const Footer = () => {
	return (
		<footer className="footer-main">
			<div className="container-main">
				<div className="footer-newsletter">
					<div className="newsletter-info">
						<h3 className="newsletter-text">Subscribe to our newsletter</h3>
						<p className="newsletter-subtext">Stay updated with the latest from Le Fille Global School.</p>
					</div>
					<div className="newsletter-form-wrap">
						<form className="newsletter-form">
							<input type="email" className="form-control" placeholder="Your email address" />
							<button className="btn text-white submit-btn-news">Subscribe</button>
						</form>
					</div>
				</div>

				<div className="row">
					<div className="col-lg-4 mb-5 mb-lg-0">
						<div className="footer-box">
							<img src={logo} className="footer-logo" alt="Le Fille Logo" />
							<p className="footer-sub-text">
								Empowering young women through a global curriculum, integrated entrance coaching, and a safe, nurturing environment.
							</p>
							<div className="social-media-icons">
								<a href="#"><i className="ri-instagram-line"></i></a>
								<a href="#"><i className="ri-whatsapp-line"></i></a>
								<a href="#"><i className="ri-facebook-circle-line"></i></a>
								<a href="#"><i className="ri-twitter-x-line"></i></a>
							</div>
						</div>
					</div>
					
					<div className="col-lg-2 col-md-4 mb-4 mb-md-0">
						<div className="footer-box">
							<h4 className="footer-heading-sub-main">Quick Links</h4>
							<ul>
								<li><Link to="/about">About Us</Link></li>
								<li><Link to="/acadamics">Programs</Link></li>
								<li><Link to="/admission">Admissions</Link></li>
								<li><Link to="/contact">Contact Us</Link></li>
							</ul>
						</div>
					</div>

					<div className="col-lg-3 col-md-4 mb-4 mb-md-0">
						<div className="footer-box">
							<h4 className="footer-heading-sub-main">Our Programs</h4>
							<ul>
								<li><Link to="/acadamics">Integrated +1 & +2</Link></li>
								<li><Link to="/acadamics">NEET / JEE Coaching</Link></li>
								<li><Link to="/acadamics">KEAM & CUET Prep</Link></li>
								<li><Link to="/acadamics">Global University Pathways</Link></li>
								<li><Link to="/acadamics">AI & Future Skills</Link></li>
							</ul>
						</div>
					</div>

					<div className="col-lg-3 col-md-4">
						<div className="footer-box">
							<h4 className="footer-heading-sub-main">Contact Us</h4>
							<ul>
								<li><a href="#"><i className="ri-map-pin-line"></i> Kuttiady, Kozhikode, Kerala</a></li>
								<li><a href="#"><i className="ri-phone-line"></i> +91 90000 00000</a></li>
								<li><a href="#"><i className="ri-mail-line"></i> lafillecampus@gmail.com</a></li>
								<li><span style={{ fontSize: '14px', color: '#888' }}><i className="ri-time-line"></i> Mon - Sat: 8 AM - 5 PM</span></li>
							</ul>
						</div>
					</div>
				</div>

				<div className="row mt-5">
					<div className="col-lg-12">
						<p className="copy-text">
							&copy; {new Date().getFullYear()} Le Fille Global School. All rights reserved. Crafted with passion for future leaders.
						</p>
					</div>
				</div>
			</div>
		</footer>
	)
}

export default Footer
